import React, { useEffect, useState } from 'react';
import ReactHTMLTableToExcel from "react-html-table-to-excel";
import { useDispatch, useSelector } from 'react-redux';
import { getAchInformationRpt, getAchSubcontractorRecruiterRpt, loadAchInformationRpt, loadAchSubcontractorRecruiterRpt } from '../../../store/reports';
import { getFormatedNumber } from '../../../../services/appService';
import GeneratePdf from '../../../../components/GeneratePdf';


const AchInformation = (props) => {

    const { type } = props;

    const [parterAchReports, setPartnerReports] = useState([]);
    const [pdfShowHide, setPdfShowHide] = useState(false);
    const [selectedCol, setSelectedCol] = useState([]);
    const [selectedColData, setSelectedColData] = useState([]);
    const [selectedAchType, setSelectedAchType] = useState(0);

    const achTypes = [
        { id: 1, name: "Sub-Contractors", pmId: 3 },
        { id: 2, name: "Recruiter", pmId: 5 },
        { id: 3, name: "W2 Candidate", pmId: 69 },
        { id: 4, name: "1099 Candidate", pmId: 70 },
    ];

    const achInformationRptSelector = useSelector(getAchInformationRpt)
    const dispatch = useDispatch();


    // useEffect(() => {
    //     if (type)
    //         dispatch(loadAchSubcontractorRecruiterRpt(type, 0, 0))
    // }, [type]);

    useEffect(() => {
        setPartnerReports(achInformationRptSelector);
    }, [achInformationRptSelector])


    const subcontractorExportPDF = () => {
        let headers = [
            [
                "ID",
                "Company Name",
                "Company Email",
                "Company Phone",
                "Bank Name",
                "Routing #",
                "Account #",
                "Account Type",
                "Key Contact ID",
                "Key Contact Name",
                "Key Contact Email",
                "Key Contact Phone",
            ],
        ];

        if(selectedAchType > 5){
            headers = [
                [
                    "ID",
                    "Name",
                    "Email",
                    "Phone",
                    "Bank Name",
                    "Routing #",
                    "Account #",
                    "Account Type",
                ],
            ];
        }

        let data = [];
        parterAchReports.map((item) =>
            selectedAchType > 5 ?
                data.push([
                    item.keyId,
                    item.keyName,
                    item.keyEmail,
                    item.keyPhone,
                    item.bank,
                    item.rounting,
                    item.account,
                    item.accountType
                ]) :
                data.push([
                    item.id,
                    item.name,
                    item.email,
                    item.phone,
                    item.bank,
                    item.rounting,
                    item.account,
                    item.accountType,
                    item.keyId,
                    item.keyName,
                    item.keyEmail,
                    item.keyPhone
                ])
        );
        setSelectedCol(headers);
        setSelectedColData(data);
        setPdfShowHide(true);

    };

    const handlepdfShowHide = () => {
        setPdfShowHide(false);
        setSelectedCol([]);
        setSelectedColData([]);
    };

    const handleGenerateRpt = () => {
        if (selectedAchType)
            dispatch(loadAchInformationRpt(selectedAchType, 0, 0))
    }

    const handleAchTypeChange = ({ currentTarget }) => {
        setSelectedAchType(currentTarget.value);
        setPartnerReports([]);
    }

    return (
        <>
            <div className="card shadow-none border">
                <div className="card-header text-center p-3 bg-lighter">
                    <h4 className="mb-0">
                        ACH Information Reports
                    </h4>
                </div>
                <div className="card-body p-3">
                    <div className="row">
                        <div className="col-md-6">
                            <select
                                name="year"
                                id="year"
                                className="form-control form-control-sm"
                                onChange={handleAchTypeChange}
                                value={selectedAchType}
                            >
                                <option value="0">Select Entity</option>
                                {achTypes.map((y) => (
                                    <option value={y.pmId}>
                                        {y.name}
                                    </option>
                                ))}
                            </select>
                        </div>
                        <div className="col-md-3">
                            <button
                                className="btn btn-sm btn-outline-default"
                                disabled={selectedAchType === 0}
                                onClick={handleGenerateRpt}
                            >
                                Generate
                            </button>
                        </div>
                        <div className="col-md-3 text-right">
                            <ReactHTMLTableToExcel
                                id="subcontractorTable"
                                className="btn btn-sm btn-outline-default"
                                table="sub_ach_rpt"
                                filename="ACH_Report"
                                sheet="ACH_Report"
                                buttonText="Export to Excel"
                            />
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-default"
                                disabled={parterAchReports?.length === 0}
                                onClick={subcontractorExportPDF}
                            >
                                Generate PDF
                            </button>
                        </div>
                        <div className="col-md-12 mt-3">
                            <div className="table-responsive">
                                <table
                                    className="table align-items-center table-flush table-hover table-striped mb-2 border"
                                    id="sub_ach_rpt"
                                >
                                    {selectedAchType > 5 ? <thead className="thead-light">
                                        <th>ID</th>
                                        <th>Name</th>
                                        <th>Email</th>
                                        <th>Phone</th>
                                        <th>Bank Name</th>
                                        <th>Routing #</th>
                                        <th>Account #</th>
                                        <th>Account Type</th>
                                    </thead> : <thead className="thead-light">
                                        <th>ID</th>
                                        <th>Company Name</th>
                                        <th>Company Email</th>
                                        <th>Company Phone</th>
                                        <th>Bank Name</th>
                                        <th>Routing #</th>
                                        <th>Account #</th>
                                        <th>Account Type</th>
                                        <th>Key Contact ID</th>
                                        <th>Key Contact Name</th>
                                        <th>Key Contact Email</th>
                                        <th>Key Contact Phone</th>
                                    </thead>}

                                    <tbody>
                                        {parterAchReports?.map(item =>
                                            selectedAchType > 5 ?
                                                <tr>
                                                    <td>{item.keyId}</td>
                                                    <td>{item.keyName}</td>
                                                    <td>{item.keyEmail}</td>
                                                    <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                    <td>{item.bank}</td>
                                                    <td>{item.rounting}</td>
                                                    <td>{item.account}</td>
                                                    <td>{item.accountType}</td>
                                                </tr> :
                                                <tr>
                                                    <td>{item.id}</td>
                                                    <td>{item.name}</td>
                                                    <td>{item.email}</td>
                                                    <td>{item.phone && getFormatedNumber(item.phone)}</td>
                                                    <td>{item.bank}</td>
                                                    <td>{item.rounting}</td>
                                                    <td>{item.account}</td>
                                                    <td>{item.accountType}</td>
                                                    <td>{item.keyId}</td>
                                                    <td>{item.keyName}</td>
                                                    <td>{item.keyEmail}</td>
                                                    <td>{item.keyPhone && getFormatedNumber(item.keyPhone)}</td>
                                                </tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <GeneratePdf
                handlepdfShowHide={handlepdfShowHide}
                pdfShowHide={pdfShowHide}
                selectedCol={selectedCol}
                selectedColData={selectedColData}
            ></GeneratePdf>
        </>
    );
};

export default AchInformation;